import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Button, IcoArchive, IcoDownload, PopoverCentralAjuda, SafeHTML } from '../../../components';
import { CustomLabel, CustomTooltip, RenderLegend, colors, graficoOptions } from './graficoOptions';
import { Bar, BarChart, Brush, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { PageLoadView, convertChart } from '../../../helpers';

export default ({ nlsContexto, nls, imprimir }) => {
  const dispatch = useDispatch()
  const { projeto, grafico, graficoLoad } = useSelector(state=> state.rankingclientecsatState)
  const { titlePage } = useSelector(state=> state.layoutState)
  const [download, setDownload] = useState(false)

  const idarray = [204];

  const handleDownload = async (e) => {
    setDownload(true)
    const chartdownload = await convertChart({id: 'graficos-chart-box', titlePage})
    setDownload(chartdownload)
  }

  return (
    <>
      <div
  id='graficos-chart-box'
  data-cy='csatstores-result'
  className={`box-rankingclientecsat-graficos box-content ${download?'graficos-download':''}`}
>
        <div className='graficos-chart-box-action'>
          <PopoverCentralAjuda cy='help' nlsContexto={nlsContexto} idarray={idarray} />
          {!graficoLoad?<Button data-cy='chart-download' type='btn circle' color='primary' variant='outlined' onClick={()=> handleDownload()} title={nls.downloadgrafico}><IcoDownload /></Button>:null}
        </div>
        <div id='graficos-chart' data-cy='csatstores-chart' className="box-rankingclientecsat-graficos-chart">
          <h3>{titlePage}</h3>
          <PageLoadView
           load={graficoLoad} 
           data={grafico.data}
           semdadosparaexibir={!imprimir ? nls.semdadosparaexibir : null}
          >
            {imprimir ? (
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                width={graficoOptions.BarChart.width}
                height={graficoOptions.BarChart.height}
                data={grafico.data}
                margin={graficoOptions.BarChart.margin}
              >
                <CartesianGrid
                  stroke={graficoOptions.CartesianGrid.stroke} 
                  vertical={graficoOptions.CartesianGrid.vertical} 
                />
                {
                  grafico.data && !(grafico.data.length <= graficoOptions.Brush.endIndex)?
                  <Brush
                    dataKey={graficoOptions.Brush.dataKey} 
                    height={graficoOptions.Brush.height} 
                    stroke={graficoOptions.Brush.stroke} 
                    startIndex={graficoOptions.Brush.startIndex}
                    endIndex={graficoOptions.Brush.endIndex}
                  />
                  :null
                }
                <XAxis 
                  dataKey={graficoOptions.XAxis.dataKey} 
                  stroke={graficoOptions.XAxis.stroke} 
                  axisLine={graficoOptions.XAxis.axisLine} 
                  tickLine={graficoOptions.XAxis.tickLine} 
                  fontSize={graficoOptions.XAxis.fontSize} 
                />
                <YAxis 
                  unit={graficoOptions.YAxis.unit} 
                  stroke={graficoOptions.YAxis.stroke} 
                  axisLine={graficoOptions.YAxis.axisLine} 
                  tickLine={graficoOptions.YAxis.tickLine} 
                  fontSize={graficoOptions.YAxis.fontSize} 
                />
                <Tooltip content={<CustomTooltip labels={grafico.labels} msgNA={nls.Dadonaodisponivel}/>} />
                <Legend content={<RenderLegend  labels={grafico.labels} />} />
                {
                  grafico.labels?.map((label, i)=> <Bar 
                    key={`bar-${label.type}-${i}`}
                    dataKey={label.type} 
                    fill={label.color} 
                    radius={graficoOptions.Bar.radius} 
                    label={<CustomLabel />}
                  />)
                }
              </BarChart>
            </ResponsiveContainer>
          ) : null}
          </PageLoadView>
        </div>


        

        {imprimir && (
          <div
  className="box-rankingclientecsat-graficos-chart-info"
  data-cy='ranking-stats'
>
  <span
  data-cy='ranking-mean'
  data-cy-value={grafico.media}
>
  <strong>{nls.media} </strong> {grafico.media}
</span>
<span
  data-cy='ranking-stddev'
  data-cy-value={grafico.desvio}
>
  <strong>{nls.desviopadrao} </strong> {grafico.desvio}
</span>
</div>
        )}


      </div>
      {
        imprimir && grafico.analiseGrafica?
        <div className='box-rankingclientecsat-analise-grafica box-content' data-cy='csatstores-analysis'>
          <h3><IcoArchive/>  {nls.analise}</h3>

          {/* Substituído dangerouslySetInnerHTML pelo componente SafeHTML */}
          <SafeHTML html={grafico.analiseGrafica} />
        
        </div>
        :null
      }
    </>
  )
}
